import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntegrationsModule } from '@integrations';

import { AccountModule } from './account/account.module';
import { UserModule } from './user/user.module';

@NgModule({
  imports: [CommonModule, AccountModule, UserModule, IntegrationsModule],
})
export class AccountUsersModule {}
